module.exports = "\r\n<div class=\"container single-page\">\r\n  <router-outlet></router-outlet>\r\n</div><!-- .container -->\r\n\r\n"